<template>
	<div class="vx-row">
		<div class="vx-col w-full">
			<h4 class="mb-6"><strong>Detail Pengajuan</strong></h4>
			<table class="mb-12 w-full">
				<tr>
					<th class="text-grey mb-3">
						Nama Lengkap
					</th>
					<td class="mb-3">
						<strong>{{savedPm ? savedPm.name : ''}}</strong>
					</td>
				</tr>
				<tr>
					<th class="text-grey mb-3">
						Pekerjaan
					</th>
					<td class="mb-3">
						<strong>{{savedPm ? savedPm.pekerjaan : ''}}</strong>
					</td>
				</tr>
				<!-- <tr>
					<th class="text-grey mb-3">
						Tipe Pengajuan Dana
					</th>
					<td class="mb-3">
						<strong>{{savedPm.tipe}}</strong>
					</td>
				</tr>
				<tr>
					<th class="text-grey mb-3">
						Metode Pengambilan
					</th>
					<td class="mb-3">
						<strong>{{savedPm.metode}}</strong>
					</td>
				</tr> -->
				<tr>
					<th class="text-grey mb-3">
						Jumlah Pengajuan Dana
					</th>
					<td class="mb-3">
						<strong>{{savedPm ? savedPm.jumlah_kebutuhan : ''}}</strong>
					</td>
				</tr>
				<tr>
					<th class="text-grey mb-3">
						Kebutuhan
					</th>
					<td class="mb-3">
						<strong>{{savedPm ? savedPm.deskripsi_kebutuhan : ''}}</strong>
					</td>
				</tr>
			</table>
			<vs-divider></vs-divider>
			<h4 class="mb-6"><strong>Berkas Pengajuan</strong></h4>
			<table class="mb-8">
				<tr>
					<th class="mb-3">
						<strong>KTP Penerima</strong>
					</th>
					<td class="mb-3">
						<strong v-if="savedPm && savedPm.file_ktp" class="text-success">{{ savedPm ? savedPm.file_ktp.name : '' }}</strong>
					</td>
				</tr>
				<tr>
					<th class="mb-3">
						<strong>Evidence</strong>
					</th>
					<td class="mb-3">
						<strong v-if="savedPm && savedPm.file_evidence" class="text-success">{{ savedPm ? savedPm.file_evidence.name : '' }}</strong>
					</td>
				</tr>
			</table>
			<div class="vx-row">
				<div class="vx-col w-full md:w-1/2">
					<vs-button class="w-full" type="border" color="light" @click.prevent="back()">
						<strong class="text-primary">Sebelumnya</strong>
					</vs-button>
				</div>
				<div class="vx-col w-full md:w-1/2">
					<vs-button class="w-full" id="btn-submit" @click.prevent="submit">
						Selanjutnya
					</vs-button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { mapState } from 'vuex'
	export default {
		props: ['data'],
		methods: {
			back() {
				this.$emit('back')
			},
			submit() {
				this.$emit('submit')
			}
		},
		computed: {
			...mapState('campaign', ['savedPm'])
		}
	}
</script>